// ProfileHero — Cover image + avatar + bio + sosyal medya butonlari
import { ExternalLink, MapPin, Calendar, Edit3 } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'

// Sosyal medya ikonlari (SVG inline, lucide'da yok)
const SOCIAL_ICONS: Record<string, string> = {
  twitter: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z',
  instagram: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z',
  youtube: 'M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z',
  tiktok: 'M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z',
  linkedin: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
}

export interface SocialAccount {
  platform: string
  url: string
  username?: string
}

export interface PortfolioUser {
  id: number
  username: string
  display_name: string
  bio?: string
  avatar_url?: string
  cover_url?: string
  cover_color?: string
  location?: string
  created_at?: string
  social_accounts?: SocialAccount[]
}

interface Props {
  user: PortfolioUser
  isOwner: boolean
  onEdit?: () => void
}

export default function ProfileHero({ user, isOwner, onEdit }: Props) {
  const coverRef = useRef<HTMLDivElement>(null)
  const [scrollY, setScrollY] = useState(0)

  // Parallax efekti
  useEffect(() => {
    const handler = () => setScrollY(window.scrollY)
    window.addEventListener('scroll', handler, { passive: true })
    return () => window.removeEventListener('scroll', handler)
  }, [])

  const coverBg = user.cover_url
    ? `url(${user.cover_url})`
    : user.cover_color
      ? `linear-gradient(135deg, ${user.cover_color}88, #764ba2cc)`
      : 'linear-gradient(135deg, #667eea, #764ba2, #f093fb)'

  const displayName = user.display_name || user.username

  return (
    <header style={{ borderRadius: 20, overflow: 'hidden', position: 'relative' }}>
      {/* Cover — parallax */}
      <div
        ref={coverRef}
        style={{
          height: 220, background: coverBg, backgroundSize: 'cover',
          backgroundPosition: `center ${50 + scrollY * 0.15}%`,
          position: 'relative',
        }}
      >
        {/* Glassmorphism overlay */}
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(180deg, transparent 40%, rgba(0,0,0,0.6) 100%)',
        }} />
        {isOwner && (
          <button
            onClick={onEdit}
            aria-label="Edit profile"
            style={{
              position: 'absolute', top: 16, right: 16, display: 'flex',
              alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 10,
              background: 'rgba(255,255,255,0.12)', backdropFilter: 'blur(12px)',
              border: '1px solid rgba(255,255,255,0.2)', color: '#fff',
              fontSize: 13, fontWeight: 600, cursor: 'pointer',
            }}
          >
            <Edit3 size={14} /> Edit
          </button>
        )}
      </div>

      {/* Profil bilgileri */}
      <div style={{
        padding: '0 32px 28px', marginTop: -50, position: 'relative', zIndex: 2,
        background: 'var(--card-bg, #161b22)',
        borderTop: '1px solid var(--border-default, #30363d)',
      }}>
        {/* Avatar — gradient ring */}
        <div style={{
          width: 100, height: 100, borderRadius: '50%', padding: 4,
          background: 'linear-gradient(135deg, #667eea, #764ba2, #f093fb)',
          marginTop: -50, marginBottom: 14, boxShadow: '0 8px 32px rgba(102,126,234,0.3)',
        }}>
          <div style={{
            width: '100%', height: '100%', borderRadius: '50%', overflow: 'hidden',
            background: 'var(--card-bg, #161b22)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            {user.avatar_url ? (
              <img src={user.avatar_url} alt={displayName} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
              <span style={{ fontSize: 36, fontWeight: 800, color: '#667eea' }}>
                {displayName[0]?.toUpperCase()}
              </span>
            )}
          </div>
        </div>

        {/* Isim + bio */}
        <h1 style={{ fontSize: 24, fontWeight: 800, color: 'var(--text-primary, #e6edf3)', margin: '0 0 4px' }}>
          {displayName}
        </h1>
        <p style={{ fontSize: 14, color: 'var(--text-secondary, #8b949e)', margin: '0 0 12px' }}>
          @{user.username}
        </p>

        {user.bio && (
          <p style={{ fontSize: 14, color: 'var(--text-secondary, #8b949e)', lineHeight: 1.7, maxWidth: 560, margin: '0 0 16px' }}>
            {user.bio}
          </p>
        )}

        {/* Meta bilgiler */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap', marginBottom: 16 }}>
          {user.location && (
            <span style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, color: 'var(--text-secondary, #8b949e)' }}>
              <MapPin size={13} /> {user.location}
            </span>
          )}
          {user.created_at && (
            <span style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, color: 'var(--text-secondary, #8b949e)' }}>
              <Calendar size={13} /> Joined {new Date(user.created_at).toLocaleDateString('en-US', { month: 'short', year: 'numeric' })}
            </span>
          )}
        </div>

        {/* Sosyal medya butonlari */}
        {user.social_accounts && user.social_accounts.length > 0 && (
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {user.social_accounts.map(acc => (
              <a
                key={acc.platform}
                href={acc.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={acc.platform}
                style={{
                  display: 'flex', alignItems: 'center', gap: 6, padding: '7px 14px',
                  borderRadius: 10, background: 'rgba(255,255,255,0.04)',
                  border: '1px solid var(--border-default, #30363d)',
                  color: 'var(--text-secondary, #8b949e)', fontSize: 12, fontWeight: 600,
                  textDecoration: 'none', transition: 'all 0.2s',
                }}
              >
                {SOCIAL_ICONS[acc.platform] ? (
                  <svg width={14} height={14} viewBox="0 0 24 24" fill="currentColor">
                    <path d={SOCIAL_ICONS[acc.platform]} />
                  </svg>
                ) : (
                  <ExternalLink size={13} />
                )}
                {acc.username || acc.platform}
              </a>
            ))}
          </div>
        )}
      </div>
    </header>
  )
}
